import { URL } from '../../../constants/reading/ApiConstants';
import CompositeClient from '../shared/CompositeClient';

const { D8_COMPOSITE_INTERPS_URL } = URL;

export default new CompositeClient(D8_COMPOSITE_INTERPS_URL);
